import { Input } from "@/components/ui/input";
import * as React from "react";
import { SearchIcon } from "lucide-react";
import clsx from "clsx";

export const SearchInput = (props: React.ComponentProps<"input">) => {
  const { className, ...rest } = props;

  return (
    <div className="relative">
      <div className="absolute left-2.5 flex h-full items-center">
        <SearchIcon className="size-3.5 shrink-0 " />
      </div>
      <Input {...rest} className={clsx("text-xs pl-8 w-[17.375rem] border border-color-icon", className)} />
    </div>
  );
};
